import React from 'react';
import { ListGroup } from 'react-bootstrap';

const DatasetViewerContextMenu = ({ contextMenu, closeContextMenu }) => {
  if (!contextMenu) return null;

  return (
    <ListGroup
      className="position-fixed bg-white border rounded shadow"
      style={{
        zIndex: 1300,
        minWidth: '198px',
        maxHeight: '50vh',
        overflow: 'auto',
        left: Math.min(contextMenu.x, window.innerWidth - 210),
        top: Math.min(contextMenu.y, window.innerHeight - 210)
      }}
    >
      {contextMenu.items.map((item, idx) => (
        <ListGroup.Item action key={idx} className="d-flex align-items-center gap-2 px-2 py-1" onClick={item.action}>
          <span style={{ width: '16px', textAlign: 'center', opacity: 0.8 }}>{item.icon}</span>
          <span>{item.label}</span>
        </ListGroup.Item>
      ))}
    </ListGroup>
  );
};

export default DatasetViewerContextMenu;
